import de from "./de";
import en from "./en";
import es from "./es";
import it from "./it";
import fr from "./fr";
import zhCn from "./zh-CN";
import zhTw from "./zh-TW";

export default {
  de,
  en,
  es,
  it,
  fr,
  "zh-CN": zhCn,
  "zh-TW": zhTw,
};
